var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#B22222",
    width: "20pt",
    height: "20pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350 35c-135.1 0-245 109.9-245 245s109.9 245 245 245 245-109.9 245-245-109.9-245-245-245zm103.07 323.4c7 6.8242 7 17.852 0 24.676-3.3242 3.5-7.875 5.25-12.25 5.25-4.5508 0-8.9258-1.75-12.426-5.25l-78.398-78.398-78.398 78.398c-3.5 3.5-7.875 5.25-12.426 5.25-4.375 0-8.9258-1.75-12.25-5.25-7-6.8242-7-17.852 0-24.676l78.398-78.398-78.398-78.398c-7-6.8242-7-17.852 0-24.676 6.8242-7 17.852-7 24.676 0l78.398 78.398 78.398-78.398c6.8242-7 17.852-7 24.676 0 7 6.8242 7 17.852 0 24.676l-78.398 78.398z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e2fb537eb7005d7748cce777f1f76b5d.svg";
export { ForwardRef as ReactComponent };